let translateAMEKE = {
	renameSearch: 'Rename search',
	deleteSearch: 'Delete search',
	deleteSearches: 'Delete searches',
	deleteSearchQuestion: 'Are you sure want to delete this search from saved searches?',
	deleteSearchesQuestion: 'Are you sure want to delete all of your saves searches?',
	noSearches: 'No searches',
	searchesCount: 'You have <strong> {{count}} saved search(es)</strong>',
	deleteAllSavedSearchesButtonText: 'Delete all',
	startSearchButtonText: 'Start search'
};

export default translateAMEKE;
